import React from "react";
import { Link } from "react-router-dom";
import {
  FlaskConical,
  ShieldCheck,
  FileText,
  Wallet,
  RefreshCcw,
  BellRing,
  ArrowRight,
} from "lucide-react";
import { siteContent } from "../content/siteContent";

const iconMap = {
  FlaskConical,
  ShieldCheck,
  FileText,
  Wallet,
  RefreshCcw,
  BellRing,
};

const ServiceCard = ({ icon, title, excerpt }) => {
  const Icon = iconMap[icon] || FileText;
  return (
    <div className="group bg-white rounded-xl p-8 shadow-[0_2px_18px_rgba(26,58,110,0.06)] hover:shadow-[0_8px_32px_rgba(34,184,219,0.18)] transition-all duration-300 border border-slate-100 hover:border-[#22b8db]/30 hover:-translate-y-1">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-14 h-14 rounded-lg bg-cyan-50 flex items-center justify-center text-[#22b8db] group-hover:bg-[#22b8db] group-hover:text-white transition-colors">
          <Icon className="w-7 h-7" strokeWidth={1.6} />
        </div>
        <h3 className="text-[17px] font-bold text-[#1a3a6e] leading-snug flex-1">
          {title}
        </h3>
      </div>
      <p className="text-slate-500 text-[14px] leading-relaxed mb-5">{excerpt}</p>
      <Link
        to="/solutions"
        className="inline-flex items-center gap-2 text-[#1a3a6e] font-semibold text-sm hover:text-[#22b8db] transition-colors"
      >
        Learn More <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

const ServicesSection = () => {
  const { kicker, title, services } = siteContent.servicesSection;
  return (
    <section className="bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="text-[#22b8db] font-semibold tracking-widest uppercase text-xs mb-3">
            {kicker}
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a3a6e]">
            {title}
          </h2>
          <div className="w-16 h-1 bg-[#22b8db] rounded-full mx-auto mt-5" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.map((s) => (
            <ServiceCard key={s.slug} {...s} />
          ))}
        </div>

        <div className="flex justify-center mt-12">
          <Link
            to="/solutions"
            className="inline-flex items-center gap-2 bg-[#22b8db] hover:bg-[#1ea3c2] text-white px-8 py-3.5 rounded-md font-semibold text-sm tracking-wide transition-colors shadow-md"
          >
            Discover More <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
